<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4.00098C7.58167 4.00098 4 7.58263 4 12.001C4 16.4182 7.58159 20 12 20C16.4184 20 20 16.4182 20 12.001C20 7.58263 16.4183 4.00098 12 4.00098ZM2 12.001C2 6.47806 6.47709 2.00098 12 2.00098C17.5229 2.00098 22 6.47806 22 12.001C22 17.523 17.5228 22 12 22C6.47717 22 2 17.523 2 12.001Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
